"use strict";
'use es6';
/*
    Transforms an `InteractionRecord` to a `LocalInteraction` for local storage.
    Interactions that persist additional data should provide additional transforms.
  */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toLocalInteraction = toLocalInteraction;
exports.toInteractionRecord = toInteractionRecord;

function toLocalInteraction(interactionRecord, localInteraction) {
  var rawEditorContent = null;

  if (interactionRecord.richTextEditorResults.hasContent()) {
    rawEditorContent = interactionRecord.richTextEditorResults.toRawEditorContent();
  }

  return localInteraction.set('rawEditorContent', rawEditorContent).set('ownerIds', interactionRecord.associations.get('ownerIds')).set('savable', interactionRecord.savable);
}

function toInteractionRecord(localInteraction, interactionRecord) {
  var associations = interactionRecord.associations.set('ownerIds', localInteraction.get('ownerIds'));
  return interactionRecord.set('rawEditorContent', localInteraction.get('rawEditorContent')).set('associations', associations).set('savable', localInteraction.get('savable'));
}